module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/1_2b5af97531251b2c2a9f27bc445ccb7f.jpg";